import React, { useContext } from 'react';
import ThrottlingCheckbox from 'integrations/components/ThrottlingCheckbox';
import AdditionalFields from 'integrations/aws/common/AdditionalFields';

import { Input } from 'components/bootstrap';

import { FormDataContext } from './context/FormData';
import { AdvancedOptionsContext } from './context/AdvancedOptions';
import type { HandleFieldUpdateType, FormDataContextType, AdvancedOptionsContextType } from './types';

interface Props {
  onChange: HandleFieldUpdateType;
}

const FormAdvancedOptions = ({ onChange }: Props) => {
  const { formData } = useContext<FormDataContextType>(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } =
    useContext<AdvancedOptionsContextType>(AdvancedOptionsContext);

  const { f5ThrottleEnabled, f5StoreFullMessage, disableTLSCheck } = formData;

  const handleToggle: (visible: boolean) => void = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };

  return (
    <AdditionalFields title="Advanced Options" visible={isAdvancedOptionsVisible} onToggle={handleToggle}>
      <ThrottlingCheckbox id="f5ThrottleEnabled" defaultChecked={f5ThrottleEnabled?.value} onChange={onChange} />
      <Input
        id="f5StoreFullMessage"
        type="checkbox"
        value="enable-storeFullMessage"
        defaultChecked={f5StoreFullMessage?.value}
        onChange={onChange}
        label="Store Full Message"
        help="Store the full original F5Networks log record message as full_message?"
      />
      <Input
        id="disableTLSCheck"
        type="checkbox"
        value="disable-TLSCheck"
        defaultChecked={disableTLSCheck?.value}
        onChange={onChange}
        label="Disable TLS Validation"
        help="Disable the TLS validation and trust all connection?"
      />
    </AdditionalFields>
  );
};

export default FormAdvancedOptions;
